/**
 * Created by neo on 07.05.21.
 */
import { makeAutoObservable } from 'mobx';

export type GoogleTtsInput = {
  text?: string;
  ssml?: string;
};

export function createGoogleTtsInput(json?: Partial<GoogleTtsInput>): GoogleTtsInput {
  return makeAutoObservable({
    text: json?.text,
    ssml: json?.ssml,
  });
}
